import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ChangeLogHistory } from 'scenes/Producer/Product/MyProducts/components/QuickView/components/ProductChangeHistory/ChangeHistoryContent/ChangeHistoryDetails/constants';
import productChangeHistoryService from 'v2/services/ProductChangeHistory';

type Payload = {
  productId: number;
  historyId: number;
};

export function useProductChangeHistoryDetails(
  { productId, historyId }: Payload,
  options: Omit<UseQueryOptions<ChangeLogHistory[]>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery({
    queryKey: ['product', productId, 'changeHistory', historyId],
    queryFn: () => productChangeHistoryService.getChangeHistoryDetails(productId, historyId),
    ...options
  });
}
